/** Display names for comparison page layouts in the Add Feature Section picker. */
export const MARKETING_COMPARISON_LAYOUT_PICKER_COPY = {
  HERO: {
    label: 'Comparison Hero Layout',
    description: 'Hero section with brand-vs-competitor pill, headline and subheading'
  },
  VALUE_GRID: {
    label: 'Four Cards Grid',
    description: 'Four-card benefits grid with icons, text and optional background image'
  },
  FEATURE_SECTION: {
    label: 'Feature Comparison (Z-Pattern)',
    description: 'Outer heading plus add/remove table + image blocks'
  },
  KEY_WINS: {
    label: '6 Cards Grid',
    description: 'Six-card grid containing 3 columns of 2 cards each'
  },
  FULL_TABLE: {
    label: 'Full Comparison Table',
    description: 'Detailed feature matrix comparing TopFan with a competitor'
  },
  AUDIENCE_SUMMARY: {
    label: '2 Cards Grid',
    description: 'Two-card grid containing 1 column of 2 cards and a closing card section of full width'
  },
  TESTIMONIAL: {
    label: 'Testimonial Carousel',
    description: 'Scrollable testimonial cards with customer quotes and profile details'
  }
} as const;
